import { useState } from "react";
import { Card, CardContent } from "src/components/ui/card";
import { Input } from "src/components/ui/input";
import { useNavigate } from "react-router-dom";
import { Tabs, TabsList, TabsTrigger, TabsContent } from "src/components/ui/tabs";
import { User, ShoppingBag, Heart, MapPin, LogOut } from "lucide-react";
import Navbar from "src/components/Navbar";
import Footer from "src/components/Footer";

import AccountOrders from "src/components/AccountOrders";
import { useProtectedRoutesContext } from "src/context/ProtectedRoutes";
import { Formik } from "formik";
import { useMutation } from "@tanstack/react-query";
import { renderErrorMessage, renderSuccessMessage } from "src/assets/functions";
import { UpdateCustomer } from "src/api";



const MyAccount = () => {
    const { setUser, setToken } = useProtectedRoutesContext();
    const [activeTab, setActiveTab] = useState("account");
    let storedObject = localStorage.getItem('user');

    let firstName = "";
    let lastName = "";
    let phoneNumber = "";
    let email = "";
    let id = "";

    if (storedObject) {
        let parsedObject = JSON.parse(storedObject);
        firstName = parsedObject?.firstName;
        lastName = parsedObject?.lastName;
        phoneNumber = parsedObject?.phoneNumber;
        email = parsedObject?.email;
        id = parsedObject?.id;
    }

    const initialValues = {
        firstName: firstName,
        lastName: lastName,
        phoneNumber: phoneNumber,
        email: email,
        id: id,
    };


    const { mutate, isLoading } = useMutation(UpdateCustomer, {
        onSuccess: (data) => {
            renderSuccessMessage(data.message);
        },
        onError: (error) => renderErrorMessage(
            error.message
        ),

    });

    const navigate = useNavigate();

    return (
        <>
            <Navbar />
            <div className="container mx-auto py-10 px-4 lg:flex">
                <Tabs value={activeTab} onValueChange={setActiveTab} className="w-full lg:flex">
                    <div className="lg:w-1/5 p-4 my-account-owal">

                        <TabsList className="flex flex-col gap-2 w-full fatix-container-switch-tabs">
                            <TabsTrigger value="account" className="flex  gap-2  fatix-account-commerce">
                                <User size={16} /> My Account
                            </TabsTrigger>
                            <TabsTrigger value="orders" className="flex  gap-2 text-left">
                                <ShoppingBag size={16} /> Orders
                            </TabsTrigger>
                            <TabsTrigger value="wishlist" className="flex  gap-2 text-left"
                                onClick={() => {
                                    navigate(`/wishlist`);
                                }}
                            >
                                <Heart size={16} /> Wishlist
                            </TabsTrigger>
                            <TabsTrigger value="addresses" className="flex  gap-2 text-left">
                                <MapPin size={16} /> Addresses
                            </TabsTrigger>
                            <TabsTrigger
                                className="flex gap-2 text-left cursor-pointer"
                                onClick={() => {
                                    setToken(null);
                                    setUser(null);
                                    // localStorage.clear();
                                    window.location.reload();
                                }}
                            >
                                <LogOut size={16} />
                                Logout
                            </TabsTrigger>
                        </TabsList>
                    </div>

                    {/* Main Content */}
                    <div className="lg:w-4/5 p-4">
                        <TabsContent value="account" className="account-defense">
                            <h2 className="text-xl font-semibold mb-4 text-left">My Account</h2>
                            <Formik
                                initialValues={initialValues}
                                onSubmit={(values) => {
                                    const { phoneNumber, ...filteredValues } = values;
                                    mutate(filteredValues);
                                }}
                            >
                                {({
                                    values,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Card className="fatix-outcome">
                                            <CardContent className="space-y-4 attempt-one-fatix p-0">
                                                <Input className="accord" placeholder="First Name"
                                                    name="firstName"
                                                    value={values.firstName}
                                                    onChange={handleChange}
                                                />
                                                <Input className="accord" placeholder="Last Name"
                                                    name="lastName"
                                                    value={values.lastName}
                                                    onChange={handleChange}
                                                />
                                                <Input className="accord" placeholder="Phone Number"
                                                    name="phoneNumber"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.phoneNumber}
                                                    disabled
                                                />
                                                <Input className="accord" placeholder="Email Address"
                                                    name="email"
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    value={values.email}
                                                    disabled
                                                />
                                            </CardContent>
                                        </Card>
                                        <div className="save-changes-btn">
                                            <button type="submit" className="w-full">Save Changes</button>
                                        </div>
                                    </form>
                                )}
                            </Formik>
                        </TabsContent>

                        <TabsContent value="orders" className="account-defense">
                            <div className="container">
                                <h2 className="text-xl font-semibold mb-4 text-left">My Orders</h2>
                                <AccountOrders />
                            </div>
                        </TabsContent>

                        <TabsContent value="wishlist" className="account-defense">
                            <h2 className="text-xl font-semibold mb-4 text-left">Wishlist</h2>
                            <p className="text-left">Your saved items will appear here.</p>
                        </TabsContent>

                        <TabsContent value="addresses" className="account-defense">
                            <h2 className="text-xl font-semibold mb-4 text-left mb-14">Addresses</h2>
                            <h5 className="default-address-fatix-h5 mb-6">Default Addresses</h5>
                            <h5 className="default-address-fatix-h5">Abdulbasit Hamzat</h5>
                            <h5 className="default-address-fatix-h5-sub mt-2">22 banjoko Street Oshodi Lagos, Nigeria</h5>
                            <h5 className="default-address-fatix-h5-sub mt-2">+234 9023443234</h5>
                        </TabsContent>

                        <TabsContent value="logout" className="account-defense">

                            <p className="text-left">You have been logged out successfully.</p>
                        </TabsContent>
                    </div>
                </Tabs>
            </div>
            <Footer />
        </>
    );
};

export default MyAccount;
